import { Model } from './model';

export class TheoreticalMachine {
  constructor(
    public hash?: string,
    public code?: string,
    public name?: string,
    public description?: string,
    public workingModelGroupHash?: string,
    public active?: boolean,
    // Cadena de escalado: maquinas teoricas a probar despues de esta, en orden.
    // El orden ES la prioridad, no un detalle de presentacion.
    public escalation: TheoreticalMachine[] = [],
    // Maquinas asignadas. Solo lectura aqui: se asignan desde la ficha de maquina.
    public models: Model[] = []
  ) { }

  get codeName(): string {
    return (this.name) ? `${ this.code } — ${ this.name }` : this.code;
  }

  clone() {
    return new TheoreticalMachine(
      this.hash,
      this.code,
      this.name,
      this.description,
      this.workingModelGroupHash,
      this.active,
      (this.escalation) ? this.escalation.map(link => link.clone()) : [],
      this.models
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/theoretical-machine.ts